import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    applyShow: '',
    applyShow2: '',
    applyShow3: '',
    paihangShow: ''
  },
  getters: {
  },
  mutations: {
    applyShowFn (state, newValue) {
      console.log(newValue)
      state.applyShow = newValue
    },
    applyShowFn2 (state, newValue) {
      console.log(newValue)
      state.applyShow2 = newValue
    },
    applyShowFn3 (state, newValue) {
      console.log(newValue)
      state.applyShow3 = newValue
    },
    paihangShowFn (state, newValue) {
      console.log(newValue)
      state.paihangShow = newValue
    }
  },
  actions: {
  },
  modules: {
  }
})
